import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { SVGComponent } from '@/types/svg-component';
import { cx } from '@/utils/cx';

export type NavLinkProps = {
  title: string;
  to: string;
  activeMatcher?: (to: string, pathname: string) => boolean;
  active?: boolean;
  darkVariant?: boolean;
  Icon?: SVGComponent;
  iconOnly?: boolean;
};

export const NavLink: FC<NavLinkProps> = ({
  active,
  darkVariant,
  iconOnly,
  Icon,
  title,
  to,
}) => (
  <Button
    aria-current={active}
    as={Link}
    className={cx(
      'bg-secondary hover:bg-secondaryShade flex flex-row gap-3 rounded-md p-2 text-gray-400 hover:text-white',
      active && 'bg-secondaryShade text-white',
      darkVariant && 'bg-secondaryShade hover:bg-secondary',
      darkVariant && active && 'bg-secondary',
    )}
    to={to}
    variant="unstyled"
  >
    {Icon && <Icon />}
    {iconOnly ? null : title}
  </Button>
);
